<template>
  <el-dialog v-dialogDrag :visible.sync="dlgVisible" title="选择目录模式" width="500px" :close-on-click-modal="false"
    :close-on-press-escape="false">
    <el-form ref="form" label-position="top" size="small">
      <el-row>
        <el-col :span="24">
          <el-form-item label="请输入新的编号">
            <el-input v-model="form.folderNo" placeholder="" maxlength="30" :show-word-limit="true" size="small"></el-input>
            <div>建议只填写字母、数字、减号、下划线</div>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <span slot="footer" class="dialog-footer">
      <el-button size="small" @click="dlgVisible = false">取 消</el-button>
      <el-button v-preventReClick type="primary" size="small" @click="commit">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>

import { notBlank } from '@/CommonDP/utils/validate';

export default {

  data() {
    return {
      dlgVisible: false,
      row: {},
      form: { folderNo: "" }
    };
  },

  methods: {
    show(row) {
      this.row = row;
      this.form.folderNo = row.folderNo || "";
      this.dlgVisible = true;
    },

    async commit() {
      const success = notBlank(this.form.folderNo, "请输入表单编号");
      if (!success) {
        return;
      }
      this.$set(this.row, "folderNo", this.form.folderNo);
      this.$success("修改成功，请点击 【保存更改】 将数据提交至服务端，否会丢失数据");
      this.dlgVisible = false;
    }

  }
};
</script>
